import React from 'react'
import styled from '@emotion/styled'

import { ImageWidth } from 'common/helpers/image'
import { scaleImage } from 'common/helpers/scaleImage'

import { WebLink } from 'common/navigation/web-link'

export const Center = styled('div')({
    textAlign: 'center',

    '& img': {
        height: 'auto',
        maxWidth: '100%',
    },
})

export interface Props {
    link: string
    src: string

    altText: string
    title: string

    width: number
    height: number
}

export const ImageLink: React.FC<Props> = props => {
    const getImageSrc = (width: ImageWidth) => scaleImage(props.src, width)
    return (
        <Center>
            <WebLink to={props.link}>
                <img
                    src={getImageSrc(650)}
                    srcSet={`${getImageSrc(320)} 320w, ${getImageSrc(650)} 640w`}
                    title={props.title}
                    alt={props.altText}
                    width={props.width}
                    height={props.height}
                />
            </WebLink>
        </Center>
    )
}
